import { dateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils/dateCurrencyFormate';
import moment from 'moment';

const { dateFormats } = dateCurrencyFromatter;
function subtractMonthsFromDate(date, amount = 1) {
  // always use moment to avoid changing the original moment object if moment date is provided.
  const _date = moment(date);

  return _date.subtract(amount, 'months');
}

function getMomentDate(date) {
  if (moment.isMoment(date)) {
    return date;
  }

  return moment(date);
}

function getTimePeriod(startDate, endDate) {
  const _startDate = getMomentDate(startDate);
  const _endDate = getMomentDate(endDate);
  const shortStartDate =
    _startDate.date() +
    ' ' +
    dateCurrencyFromatter.dateTransformer(_startDate, dateFormats.monthShortName);
  const shortEndDate =
    _endDate.date() +
    ' ' +
    dateCurrencyFromatter.dateTransformer(_endDate, dateFormats.monthShortName);

  return `${shortStartDate} - ${shortEndDate}`;
}

function getYear(date) {
  const _date = getMomentDate(date);

  return _date.year();
}

function getMonth(date) {
  const _date = getMomentDate(date);

  return dateCurrencyFromatter.dateTransformer(_date, dateFormats.monthName);
}

function getShortMonth(date) {
  const _date = getMomentDate(date);

  return dateCurrencyFromatter.dateTransformer(_date, dateFormats.monthShortName);
}

function getMonthNumber(date) {
  const _date = getMomentDate(date);

  return dateCurrencyFromatter.dateTransformer(_date, dateFormats.monthShortNumber);
}

export { subtractMonthsFromDate, getTimePeriod, getYear, getMonth, getShortMonth, getMonthNumber };
